<div class="row bg-secondary-nvwa">
  <div class="container">
    <div class="">
      <h3 class="pt-3">
        {{ "COV_CERTIFICAAT.NIET_GEVONDEN_HEADER" | promptvalue | async }}
      </h3>
    </div>
  </div>
</div>
<div class="container">
  <div class="py-5">
    <div class="">
      {{ "COV_CERTIFICAAT.NIET_GEVONDEN_REGEL1" | promptvalue | async }}
    </div>
    <!--
	    <div class="pt-3">{{ "COV_CERTIFICAAT.NIET_GEVONDEN_REGEL2" | promptvalue | async }}</div>
	    <div class="pt-3">{{ "COV_CERTIFICAAT.NIET_GEVONDEN_REGEL3" | promptvalue | async }}</div>
 -->
  </div>
</div>
